import React, { useCallback, useEffect, useState } from 'react'
import ProductUi from './ProductUi'
import { useDispatch } from 'react-redux'
import { callApiAction } from '../../../store/actions/commonAction'
import { getProdutApi, ProductFindByIdApi } from '../../../apis/product.api'

const ProductController = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState([]);
    const [productId, setProductId] = useState("")

    const [data, setData] = useState({
        name: '',
        is_3yr_warranty: null,
        product_accessories: [],
        problems: [],
        item: [],
        categories: "",
    })

    const fetchProducts = useCallback(() => {
        setLoading(true);
        dispatch(
            callApiAction(
                getProdutApi,
                (response) => {
                    setProducts(response?.result || []);
                    setLoading(false);
                },
                () => setLoading(false)
            )
        )
    }, [dispatch])

    const fetchById = useCallback((id) => {
        setLoading(true)
        dispatch(
            callApiAction(
                () => ProductFindByIdApi({ id }),
                (response) => {
                    setData((prev) => ({ ...prev, ...response }));
                    setLoading(false);
                },
                () => setLoading(false)
            )
        )
    }, [dispatch])

    useEffect(() => { fetchProducts() }, [fetchProducts])
    useEffect(() => { if (productId) fetchById(productId) }, [productId, fetchById])

    return (
        <ProductUi
            loading={loading}
            data={data}
            products={products}
            productId={productId}
            setProductId={setProductId}
        />
    )
}

export default ProductController
